class ValidationErrors {
  $formValidationTitle = document.querySelector(".js-cart-validation-modal-title");

  $formValidationQty = document.querySelector(".js-cart-validation-modal-qty");

  $formValidationMade = document.querySelector(".js-cart-validation-modal-design");

  $formValidationQtyMade = document.querySelector(".js-cart-validation-modal-qty-design");

  $formValidationDimensions = document.querySelector(".js-cart-validation-modal-dimensions");

  $validationModal = document.getElementById("cart-validation-modal");

  $validationPopup = document.getElementById("cart-validation-popup");

  // eslint-disable-next-line class-methods-use-this
  #showImg($img) {
    $img.classList.remove("hidden");
    $img.setAttribute("src", $img.dataset.src);
  }

  #updateHeader(text) {
    this.$formValidationTitle.textContent = text;
  }

  #showValidationModal() {
    $(this.$validationModal).modal("show");
    const $button = this.$validationModal.querySelector("button");
    $button?.focus();
  }

  #showValidationMadeError() {
    this.#updateHeader("Please Add Your Designs First");
    this.#showImg(this.$formValidationMade);
    this.#showValidationModal();
  }

  #showValidationQtyError() {
    this.#updateHeader("Please Tell Us How Many You Want");
    this.#showImg(this.$formValidationQty);
    if (this.$validationModal) {
      this.#showValidationModal();
    } else if (this.$validationPopup) {
      this.#showValidationPopup();
    }
  }

  #showValidationMadeQtyError() {
    this.#updateHeader("Please Add Quantities and Your Designs");
    this.#showImg(this.$formValidationQtyMade);
    this.#showValidationModal();
  }

  #showValidationMadeDimensionsError() {
    this.#updateHeader("Please Check Size of Your Designs");
    this.#showImg(this.$formValidationDimensions);
    this.#showValidationModal();
  }

  #showValidationPopup() {
    this.$validationPopup.classList.remove("hidden");
    setTimeout(() => {
      this.$validationPopup.classList.add("hidden");
    }, 2000);
  }

  #resetModal() {
    this.$formValidationQty.classList.add("hidden");
    this.$formValidationMade.classList.add("hidden");
    this.$formValidationQtyMade.classList.add("hidden");
    this.$formValidationDimensions?.classList.add("hidden");
  }

  show({ hasMadeErrors, hasFormErrors, hasDimensionsErrors }) {
    this.#resetModal();

    if (hasFormErrors && !hasMadeErrors) {
      this.#showValidationQtyError();
    } else if (hasFormErrors && hasMadeErrors) {
      this.#showValidationMadeQtyError();
    } else if (!hasFormErrors && hasMadeErrors) {
      this.#showValidationMadeError();
    } else if (hasDimensionsErrors) {
      this.#showValidationMadeDimensionsError();
    }
  }
}

export default () => new ValidationErrors();
